package com.essntl.features.crm.ui

import com.essntl.features.organization.domain.model.OrganizationModel

interface CRMNavigation {
    data class AddOrganization(val type: OrganizationModel.Type) : CRMNavigation
    data class OrganizationDetails(val id: String) : CRMNavigation
    data object Toggle : CRMNavigation
    data class EditContact(val contactId: String) : CRMNavigation
}